import { chargerProductsInWishlist, initButtons } from "./HandlerWishlist";

if (document.querySelector("#openWishlist")) {
  const openWishlist = document.querySelector("#openWishlist "),
    whislistContent = document.querySelector(".wishlist-container"),
    body = document.querySelector("body"),
    closeWishlist = whislistContent.querySelector(".mini-cart__close");

  openWishlist.addEventListener("click", () => {
    whislistContent.classList.add("visible");
    body.classList.add("hidden");
    chargerProductsInWishlist();
  });
  closeWishlist.addEventListener("click", () => {
    whislistContent.classList.remove("visible");
    body.classList.remove("hidden");
    initButtons();
  });
}
